module.exports = __webpack_public_path__ + "static/media/Pasos_Fondo3.51669884.png";